import GiftCard from './GiftCard';
import enhance from './GiftCardContainer';

export default enhance(GiftCard);



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCard/index.js